package com.mencanhealth.admin.ui

import androidx.compose.runtime.*
import com.mencanhealth.admin.data.AdminFirestoreService
import com.mencanhealth.admin.model.AdminUser
import com.mencanhealth.admin.model.SubscriptionTier
import com.mencanhealth.admin.ui.components.TierBadge
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.dom.*

@Composable
fun UserDetailPage(
    firestoreService: AdminFirestoreService,
    userId: String,
    onBack: () -> Unit
) {
    var user by remember { mutableStateOf<AdminUser?>(null) }
    var saving by remember { mutableStateOf(false) }
    var message by remember { mutableStateOf<String?>(null) }
    val scope = rememberCoroutineScope()

    LaunchedEffect(userId) {
        user = firestoreService.getUser(userId)
    }

    Div({ classes("page") }) {
        Button({
            classes("btn-back")
            onClick { onBack() }
        }) { Text("\u2190 Back to Users") }

        user?.let { u ->
            H2 { Text(u.displayName ?: u.email) }

            Div({ classes("detail-card") }) {
                Div({ classes("detail-row") }) {
                    Span({ classes("detail-label") }) { Text("UID") }
                    Span { Text(u.uid) }
                }
                Div({ classes("detail-row") }) {
                    Span({ classes("detail-label") }) { Text("Email") }
                    Span { Text(u.email) }
                }
                Div({ classes("detail-row") }) {
                    Span({ classes("detail-label") }) { Text("Current Tier") }
                    TierBadge(u.tier)
                }
            }

            H3 { Text("Change Tier") }
            Div({ classes("tier-buttons") }) {
                SubscriptionTier.entries.forEach { tier ->
                    Button({
                        classes("btn-tier")
                        if (u.tier == tier) classes("btn-tier-active")
                        if (saving) attr("disabled", "true")
                        onClick {
                            scope.launch {
                                saving = true
                                try {
                                    firestoreService.updateTier(u.uid, tier)
                                    user = u.copy(tier = tier)
                                    message = "Tier updated to ${tier.name}"
                                } catch (e: Exception) {
                                    message = "Error: ${e.message}"
                                }
                                saving = false
                            }
                        }
                    }) { Text(tier.name) }
                }
            }
            message?.let { msg ->
                P({ classes(if (msg.startsWith("Error")) "error-text" else "success-text") }) {
                    Text(msg)
                }
            }
        } ?: run {
            P { Text("Loading user...") }
        }
    }
}
